import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})

export class ClientesService {

  collection(arg0: string) {
    throw new Error("Method not implemented.");
  }

  private clientesCollection: AngularFirestoreCollection<any>;
  private clientes: Observable<any[]>;

  private ruterosCliCollection: AngularFirestoreCollection<any>;
  private ruterosCliclientes: Observable<any[]>;

  private visitasCliCollection: AngularFirestoreCollection<any>;
  private visitasCliclientes: Observable<any[]>;

  constructor(private readonly db: AngularFirestore, private userd: AuthService) {


  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + ''+ EXCEL_EXTENSION);
  }


  negocio = localStorage.getItem("negocio");
  agencia = localStorage.getItem("agencia");
  fecha = localStorage.getItem("pedidoFecha");


   //*  consultar los clientes del maestro //
  getClientes() {

    this.negocio = localStorage.getItem("negocio");
    this.agencia = localStorage.getItem("agencia");
    this.fecha = localStorage.getItem("pedidoFecha");
    this.clientesCollection = this.db.collection<any>('maestrosODL/' + this.negocio + '_' + this.agencia + '/' + "clientes", ref => ref.orderBy('id_empresa'));
    this.clientes = this.clientesCollection.snapshotChanges().pipe(map(
      actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return { ...data };
      })
    ));

    return this.clientes;


  }



  getClientesInd(idcliente: String) {

    this.negocio = localStorage.getItem("negocio");
    this.agencia = localStorage.getItem("agencia");
    this.fecha = localStorage.getItem("pedidoFecha");
    this.clientesCollection = this.db.collection<any>('maestrosODL/' + this.negocio + '_' + this.agencia + '/' + "clientes", ref => ref.where('id_empresa','==',idcliente));
    this.clientes = this.clientesCollection.snapshotChanges().pipe(map(
      actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return { ...data };
      })
    ));

    return this.clientes;


  }
  getClientesDia(idcliente) {

    this.negocio = localStorage.getItem("negocio");
    this.agencia = localStorage.getItem("agencia");
    this.fecha = localStorage.getItem("pedidoFecha");

    console.log("fecha en el servicio  constual a la base", localStorage.getItem("pedidoFecha"))
    console.log("die en el servicio  constual a la base", idcliente)
    
    this.clientesCollection = this.db.collection<any>('maestrosODL/' + this.negocio + '_' + this.agencia + '/' + "clientes", ref => ref.where('dia','==',idcliente));
    this.clientes = this.clientesCollection.snapshotChanges().pipe(map(
      actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return { ...data };
      })
    ));

    return this.clientes;


  }

  createCliente(cliente: any) {

    this.negocio = localStorage.getItem("negocio");
    this.agencia = localStorage.getItem("agencia");
    this.fecha = localStorage.getItem("pedidoFecha");
    this.clientesCollection = this.db.collection<any>('maestrosODL/' + this.negocio + '_' + this.agencia + '/' + "clientes");
   
    return this.clientesCollection.doc(cliente.codigo).set(cliente);

  }

  
  createRutasOdl(ruta: any) {

    this.fecha = localStorage.getItem("pedidoFecha");

    this.negocio = localStorage.getItem("negocio");
    this.agencia = localStorage.getItem("agencia");
    this.fecha = localStorage.getItem("pedidoFecha");

    this.ruterosCliCollection = this.db.collection<any>('ruterosODL/' + this.negocio + '_' + this.agencia + '/'+ this.fecha);
  
    return this.ruterosCliCollection.doc("RUTA"+ruta.name).set(ruta);

  }

  createVistasOdl(ruta: any) {

    this.fecha = localStorage.getItem("pedidoFecha");


    this.negocio = localStorage.getItem("negocio");
    this.agencia = localStorage.getItem("agencia");
    this.fecha = localStorage.getItem("pedidoFecha");

    this.visitasCliCollection = this.db.collection<any>('visitasODL/' + this.negocio + '_' + this.agencia + '/'+ this.fecha);
  
    return this.visitasCliCollection.doc("RUTA"+ruta.idEmpresa).set(ruta);

  }
  getVistasRutas() {
  
    this.negocio = localStorage.getItem("negocio");
    this.agencia = localStorage.getItem("agencia");
    this.fecha = localStorage.getItem("pedidoFecha");
    this.visitasCliCollection = this.db.collection<any>('visitasODL/'+ this.negocio + '_' + this.agencia + '/'+ this.fecha );
    this.visitasCliclientes = this.visitasCliCollection.snapshotChanges().pipe(map(
      actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return { ...data };
      })
    ));

    return this.visitasCliclientes;

  }

  getClientesRutas() {
    this.fecha = localStorage.getItem("pedidoFecha");
    this.negocio = localStorage.getItem("negocio");
    this.agencia = localStorage.getItem("agencia");
    this.fecha = localStorage.getItem("pedidoFecha");
    this.ruterosCliCollection = this.db.collection<any>('ruterosODL/'+ this.negocio + '_' + this.agencia + '/'+this.fecha );
    this.ruterosCliclientes = this.ruterosCliCollection.snapshotChanges().pipe(map(
      actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return { ...data };
      })
    ));

    return this.ruterosCliclientes;

  }


}


